import {Injectable} from '@angular/core';
import {getCurrencySymbol} from '@angular/common';
import {Amount} from '../../domain/shared/amount';
import {LanguageService} from '../../application/service/language.service';

@Injectable({
  providedIn: 'root'
})
export class AmountFormatterService {

  constructor(private languageService: LanguageService) {
  }

  format(amount: Amount, formatter: string = '0,0.00', displayEstimate: boolean = true): string {
    if (amount === null || amount === undefined || amount.value === null) {
      return '-';
    }

    const currency = this.extractCurrency(amount);
    const formatted = this.languageService.getNumeral()(amount.value).format(formatter);

    return (displayEstimate && amount.estEstime ? '* ' : '') + formatted + ' ' + currency;
  }

  extractCurrency(amount: Amount): string {
    let currency = amount.currency;
    // fix display
    if (amount.currency === null || amount.currency === undefined) {
      currency = '€';
    } else {
      currency = getCurrencySymbol(currency, 'narrow');
    }
    return currency;
  }

  excelFormat(amount: Amount): string {
    let currency = this.extractCurrency(amount);

    // Avoid to corrupt excel for CHF Currency
    if (currency === 'CHF') {
      currency = '[$CHF-fr-CH]';
    }

    return '_ * #,##0.00_) {currency1}_ ;_ * - #,##0.00 {currency2}_ ;_ * 0.00 {currency3}_ ;_ @_ '
      .replace('{currency1}', currency)
      .replace('{currency2}', currency)
      .replace('{currency3}', currency);
  }
}
